import { CSSProperties } from 'react'

export interface KbdProps {
    shortcut?: 'command' | 'windows' | 'ctrl' | 'option' | 'shift' | 'key'
    keyLabel?: string
    variant?: 'default' | 'light'
    style?: CSSProperties
}

const symbolMap: Record<string, string> = {
    command: '⌘',
    windows: 'Win +',
    ctrl: '⌃',
    option: '⌥',
    shift: '⇧',
}

export const Kbd = ({ shortcut = 'command', keyLabel = 'K', variant = 'default', style }: KbdProps) => {
    const symbol = shortcut !== 'key' ? symbolMap[shortcut] : undefined

    // Figma: key/shift use pl-5 pr-6, option uses gap 1.41px, others use px-6 gap-2
    const isKeyOrShift = shortcut === 'key' || shortcut === 'shift'

    return (
        <kbd
            className={`inline-flex items-center whitespace-nowrap rounded-lg border-none text-sm font-medium leading-5 text-foreground-muted ${
                variant === 'default' ? 'bg-default' : 'bg-transparent'
            } ${isKeyOrShift ? 'py-px pl-[5px] pr-1.5' : 'px-1.5 py-px'} ${shortcut === 'option' ? 'gap-[1.41px]' : 'gap-0.5'}`}
            style={style}
        >
            {symbol && <span>{symbol}</span>}
            <span>{keyLabel}</span>
        </kbd>
    )
}
